// extracted by mini-css-extract-plugin
module.exports = {"labelsRow":"SliderPreview_labelsRow__ei7ZF","label":"SliderPreview_label__2PVKo"};